module.exports = __webpack_public_path__ + "media/images/top/top/img_badge-6fa6b43a690a8d09141ed9c30705be3f.svg";